import { Icon } from "./Icon.tsx";

/** "Simulating…" — replaces PlayIcon on the Run Simulation button while a worker is running (see App.tsx's own `runSimulation`); `.spinner-icon` (base.css) is what actually spins it. */
export function SpinnerIcon() {
  return (
    <span className="spinner-icon">
      <Icon>
        <path d="M12 3a9 9 0 1 0 9 9" />
      </Icon>
    </span>
  );
}
